import React, { FC } from 'react';

import { EvSelectNew, OptionType } from '@evinced-private/ui-common';

import { useCommonFiltersStore } from '../../../../providers/commonFiltersProvider/CommonFiltersProvider';
import { COMPARE_TYPE, COMPARE_TYPE_OPTIONS_LABELS } from '../../DashboardTypes';
import { DASHBOARD_FILTERS_ID, defaultFilterValues } from '../../helpers/DashboardFiltersHelper';

import './SelectLiftPriod.scss';

const SelectLiftPriod: FC = () => {
	const commonFiltersStore = useCommonFiltersStore();

	const appliedFilters = commonFiltersStore.getFilterValue(DASHBOARD_FILTERS_ID);

	const handleLiftPeriodChange = (selectedPeriod: OptionType[]): void => {
		commonFiltersStore.updateSelectedFilters(DASHBOARD_FILTERS_ID, {
			collections: appliedFilters?.collections || defaultFilterValues.collections,
			liftPeriods: [{ label: selectedPeriod[0].label, value: selectedPeriod[0].value as string }]
		});
	};

	return (
		<div className="select-lift-period">
			<EvSelectNew
				id="lift-period-select"
				options={[
					{
						label: COMPARE_TYPE_OPTIONS_LABELS[COMPARE_TYPE.COMPARE_LAST_SCANS],
						value: COMPARE_TYPE.COMPARE_LAST_SCANS
					},
					{
						label: COMPARE_TYPE_OPTIONS_LABELS[COMPARE_TYPE.COMPARE_DATE_RANGE],
						value: COMPARE_TYPE.COMPARE_DATE_RANGE
					}
				]}
				selectedValue={appliedFilters?.liftPeriods}
				onSelectChange={handleLiftPeriodChange}
				placeholder="select period to compare"
				label="Compared to"
				labelPosition="left"
			/>
		</div>
	);
};

export { SelectLiftPriod };
